module.exports = __webpack_public_path__ + "img/Online Guide Logo Red Loughborough Bellfoundry Trust.078f9066.svg";